import React, { useState, useRef } from "react";
import { useCart } from "../context/CartContext";
import "./GridPage.css";

export default function GridPage({ title, items }) {
  const { dispatch } = useCart();
  const [animatingId, setAnimatingId] = useState(null);

  const gridRef = useRef(null);

  let isDown = false;
  let startX;
  let scrollLeft;

  const onMouseDown = (e) => {
    isDown = true;
    startX = e.pageX - gridRef.current.offsetLeft;
    scrollLeft = gridRef.current.scrollLeft;
  };

  const onMouseLeave = () => (isDown = false);
  const onMouseUp = () => (isDown = false);

  const onMouseMove = (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - gridRef.current.offsetLeft;
    const walk = (x - startX) * 1.5;
    gridRef.current.scrollLeft = scrollLeft - walk;
  };

  const addToCart = (item) => {
    if (Number(item.stock) <= 0) return; // 🔥 seguridad extra

    setAnimatingId(item.id);

    dispatch({
      type: "ADD_ITEM",
      payload: {
        dishId: item.id,
        name: item.name,
        namecor: item.namecor,
        qty: 1,
        price: item.price,
        extras: [],
        acompanamientos: [],
        note: "",
        type: "grid",
      },
    });

    setTimeout(() => setAnimatingId(null), 600);
  };

  return (
    <div className="grid-container">
      <h2 className="grid-title">{title}</h2>

      <div className="scroll-hint-left">‹</div>
      <div className="scroll-hint-right">›</div>

      <div className="grid">
        {items.map((it) => {
          const sinStock = Number(it.stock) <= 0;

          return (
            <div key={it.id} className="grid-card">
              <img src={it.image} alt={it.name} className="grid-img" />

              <div className="grid-overlay">
                <h1 className="grid-name">{it.name}</h1>
                {sinStock && <div className="grid-out-stock">Sin stock</div>}

                {it.description && (
                  <p className="grid-desc">{it.description}</p>
                )}

                <div className="grid-footer">
                  <span className="grid-price">
                    ${it.price.toLocaleString()}
                  </span>

                  <button
                    className={`grid-add 
    ${animatingId === it.id ? "add-animate" : ""} 
    ${sinStock ? "grid-add-disabled" : ""}`}
                    disabled={sinStock}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!sinStock) addToCart(it);
                    }}
                  >
                    {sinStock ? "Sin stock" : "Agregar"}
                  </button>
                </div>

                {animatingId === it.id && <span className="cart-fly">+1</span>}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
